import React, { Component, Fragment } from "react";
import AppContext from "../../../contexts/AppContext";
import { Link } from "react-router-dom";

class List extends Component {
    state = {
        item: {}
    };

    render() {
        return (
            <Fragment>
                <tr>
                    <td>{this.props.item.id}</td>
                    <td>
                        <Link
                            to={`/employer/jobs/workSpace/${this.props.item.link}`}
                        >
                            {this.props.item.title}
                        </Link>
                    </td>
                    <td className="large" onClick={this.toggleApplicantModal}>
                        {this.props.item.applicants}
                    </td>
                    <td>
                        <time dateTime={this.props.item.created_at}>
                            {this.props.item.created_at}
                        </time>
                    </td>
                    <td>{this.props.item.state}</td>
                    <td className="text-left">
                        <a
                            href={`/jobs/job/${this.props.item.link}`}
                            type="button"
                            target="_blank"
                            className="btn btn-info btn-sm"
                        >
                            View
                        </a>
                    </td>
                </tr>
            </Fragment>
        );
    }
}
List.contextType = AppContext;
export default List;



// WEBPACK FOOTER //
// ./src/components/employer/jobs/List.js